import type { Bot } from "@rakazo/contracts";
import { WorkspaceSearch } from "../../components/WorkspaceSearch";
import { selectedSpaceId } from "../../lib/rpc";
import { useWindowShortcut } from "../../lib/use-window-shortcut";

export function CommandPalette({
  open,
  onOpenChange,
  bots,
  onSelectBot,
}: {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  bots: Bot[];
  onSelectBot: (id: string) => void;
}) {
  useWindowShortcut((event) => {
    if (
      !(event.metaKey || event.ctrlKey) ||
      event.altKey ||
      event.shiftKey ||
      event.repeat ||
      !/^[1-9]$/.test(event.key)
    )
      return;
    const bot = bots[Number(event.key) - 1];
    if (!bot) return;
    event.preventDefault();
    onSelectBot(bot.id);
    onOpenChange(false);
  }, open);
  return (
    <WorkspaceSearch spaceId={selectedSpaceId() ?? ""} open={open} onOpenChange={onOpenChange} />
  );
}
export { isCommandPaletteHotkey } from "./command-palette-hotkey";
